import { Model } from 'react3l-common';
import { Field } from 'react3l-decorators';

export class ActionType extends Model {
    @Field(Number)
    public id?: number;


    @Field(String)
    public name?: string;

}